import { SensorPortCommunicationMode } from "../../../portConfigs.js";
import { OUTPUT_OPERATING_MODE_RANGE } from "../../outputOperatingMode.js";
import { OUTPUT_POSITION_RANGE } from "../../outputPosition.js";
import { SensorClusterConfig } from "../types.js";

const diagnosticClusterBase: Omit<
    SensorClusterConfig<Record<string, never>>,
    "generateSensorElements" | "modelName" | "friendlyName" | "friendlyShortName"
> = {
    communicationMode: SensorPortCommunicationMode.DIGITAL,
    requiredSubChannels: [],
    optionalSubChannels: [],
    isPermanentlyAttached: true,
    parameterConfigs: {},
    manufacturerName: "Verdi",
};

export const genericDiagnosticClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    CrashCount: {
        ...diagnosticClusterBase,
        modelName: "Crash Count",
        friendlyName: "Crash Count",
        friendlyShortName: "Crashes",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "digitalCount",
                parameters: {},
                legalConvertedRange: [0, null],
                subChannel: 0,
            },
        ],
    },

    ResetCount: {
        ...diagnosticClusterBase,
        modelName: "Reset Count",
        friendlyName: "Reset Count",
        friendlyShortName: "Resets",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "digitalCount",
                parameters: {},
                legalConvertedRange: [0, null],
                subChannel: 0,
            },
        ],
    },

    /**
     * A device output — a solenoid valve, or a latching relay driving a pump.
     *
     * Sub-channel 1 is deliberately left unused: it is solenoid verification on Gen 4's output cluster,
     * and keeping the sub-channel meanings aligned across generations is worth more than closing the
     * gap. Sprout and Sapling have no solenoid verification.
     */
    Output: {
        ...diagnosticClusterBase,
        modelName: "Output State",
        friendlyName: "Output State",
        friendlyShortName: "Output",
        generateSensorElements: () => [
            {
                sensorElementConfigKey: "outputPosition",
                parameters: {},
                legalConvertedRange: OUTPUT_POSITION_RANGE,
                subChannel: 0,
            },
            {
                sensorElementConfigKey: "outputOperatingMode",
                parameters: {},
                legalConvertedRange: OUTPUT_OPERATING_MODE_RANGE,
                subChannel: 2,
            },
        ],
    },
};
